import React from 'react';



function Pagination({
  totalItems,
  itemsPerPage,
  handlePageClick,
  currentPage,
  tabIndex = 0,
}) {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const pageRange = 2; // Number of pages to show around the current page

  // Helper function to check if the page should be shown
  const shouldShowPage = (page) => {
    // Always show the first and last page
    if (page === 1 || page === totalPages) return true;
    // Show pages around the current page within the page range
    if (page >= currentPage - pageRange && page <= currentPage + pageRange)
      return true;
    return false;
  };

  const renderPageNumbers = () => {
    let pages = [];
    for (let i = 1; i <= totalPages; i++) {
      if (shouldShowPage(i)) {
        pages.push(
          <button
            key={i}
            tabIndex={tabIndex ? tabIndex + i : 0}
            onClick={() => handlePageClick(i)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handlePageClick(i);
            }}
            className={`px-3 py-1 rounded-md ${
              currentPage === i
                ? 'bg-pri text-white'
                : 'bg-white text-gray-600 hover:bg-gray-100 '
            } focus:outline-none focus:border-[3px] focus:border-[lightblue] focus:rounded-md`}
          >
            {i}
          </button>
        );
      } else if (
        i === currentPage - pageRange - 1 ||
        i === currentPage + pageRange + 1
      ) {
        pages.push(
          <span key={i} className='px-3 py-1'>
            ...
          </span>
        );
      }
    }
    return pages;
  };

  return (
    <div
      tabIndex={tabIndex}
      className='flex items-center justify-center space-x-2 mt-4 cursor-pointer focus:outline-none focus:border-[3px] focus:border-[lightblue] focus:rounded-md'
    >
      <button
        autoFocus={currentPage === 1}
        tabIndex={tabIndex}
        className='px-3 py-1 text-gray-600 bg-white rounded-md hover:bg-gray-100 cursor-pointer focus:outline-none focus:border-[3px] focus:border-[lightblue] focus:rounded-md'
        onClick={() => handlePageClick(currentPage - 1)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') handlePageClick(currentPage - 1);
        }}
        disabled={currentPage === 1}
      >
        &lt;
      </button>

      {renderPageNumbers()}

      <button
        tabIndex={tabIndex ? tabIndex + 1 : 0}
        className='px-3 py-1 text-gray-600 bg-white rounded-md hover:bg-gray-100 cursor-pointer focus:outline-none focus:border-[3px] focus:border-[lightblue] focus:rounded-md'
        onClick={() => handlePageClick(currentPage + 1)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') handlePageClick(currentPage + 1);
        }}
        disabled={currentPage === totalPages}
      >
        &gt;
      </button>
    </div>
  );
}

export default Pagination;
